import React, { useEffect, useState } from 'react'
import SearchContainer from './SearchOrderSearchContainer'
import PurchaseOrderTable from '../PurchaseOrderTable'
import { Card, CardBody, Container } from 'reactstrap'
import Drawer from 'components/Drawer'
import AddPurchaseOrder from 'components/AddPurchaseOrder'
import ErrorBoundary from 'components/ErrorBoundary'
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cloneDeep } from 'lodash'
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import useAxios from 'hooks/useAxios'
import Loader from 'components/Loader'


const SearchOrderTab = (props) => {
  const [openPharmacy, setOpenPharmacy] = useState(false);
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);

  const [ceid, setCeid] = useState("")
  const {
    reset,
    orgId,
    onSearch,
    data,
    totalitem,
    refetch,
    onReset,
    onPageChange,
    search,
    // toggleSider,
    // collIcon,
    // collapseSider,
    SelectedAccumulator,
    loading,
    setLoading,
    onSearchColumnFilters = () => '',
resetKey,
    resetFilterFlag,
    SetResetFilterFlag,
    ActiveButton,
    columnFilters,
    tabKey,
  } = props;
  const API = useAxios();
  const manvalPharmacy = () => {
    setOpenPharmacy(!openPharmacy);
  }
  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(search);
    //filterObj.ActiveButton = ActiveButton
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "searchOrder";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
    //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
    //  onExport(action, initialFilters);
  };
  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    }
    else {
      setCollIcon(faAngleUp);
    }
  }

  useEffect(() => {
    onReset();
  }, [orgId, reset]);

 
useEffect(()=>{
setOpenPharmacy(false)
},[orgId])


  return (
    <div>
      <div className="border-0">
        {/* {loading && <Loader opacity={0.01} color="black"/>} */}
        <Card className="border-0 shadow-top mb-3 durg_tabs">
          <CardBody hidden={collapseSider} className="">
            <div hidden={collapseSider} className=''>
            <ErrorBoundary>
              <SearchContainer
              reset={reset}
                manvalPharmacy={manvalPharmacy}
                orgId={orgId}
                onSearch={onSearch}
                onReset={onReset}
                refetch={refetch}
                ceid={ceid}
                setCeid={setCeid}
                setLoading={setLoading}
                tabKey={tabKey}
              />
            </ErrorBoundary>
            </div>

          </CardBody>
        </Card>
        <Card className='border-0 shadow-top'>
          <CardBody className="">
            {/* <div className="py-2 text-center">
              <span
                style={{ fontSize: "27px", cursor: "pointer" }}
                onClick={toggleSider}
              >
                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
              </span>
            </div> */}
            <ErrorBoundary>
              <PurchaseOrderTable
                search={search}
                refetch={refetch}
                SelectedAccumulator={SelectedAccumulator}
                data={data}
                orgId={orgId}
                onPageChange={onPageChange}
                totalitem={totalitem}
                filters={search}
                onExport={handleExport}
                onSearchColumnFilters={onSearchColumnFilters}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                ceid={ceid}
                setCeid={setCeid}
                resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                tabKey={tabKey}
                resetKey={resetKey}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </div>

      <Drawer
        direction="end"
        isOpen={openPharmacy}
        toggle={manvalPharmacy}
        size="lg"
        title="Add Order"
      >
        <AddPurchaseOrder
          ActiveButton={ActiveButton}
          SelectedAccumulator={SelectedAccumulator}
          toggle={manvalPharmacy}
          orgId={orgId}
          refetch={refetch}
        />
      </Drawer>
    </div>
  );
}

export default SearchOrderTab
